import Store from 'redux/Store'
import { setMessage, setSaveDeviceAndPassData } from 'redux/actions'

interface prepareSubmitFormProps {
  submitForm: Function
  data: any
  setShowOverlay: Function
  navigate: Function
  id: string | undefined
  successMessage: string
  successNav: string
  saveAndNewClicked: boolean
  isDeviceReplacement: boolean
  initiateReplacement: boolean
  setError?: Function
}

const prepareSubmitForm = async (props: prepareSubmitFormProps) => {
  props.setShowOverlay(true)

  props
    .submitForm({
      data: props.data,
      setShowOverlay: props.setShowOverlay,
      id: props.id,
      setError: props?.setError,
      isDeviceReplacement: props.isDeviceReplacement,
    })
    .then((response: any) => {
      if (response?.status === 200 || response?.status === 201) {
        Store.dispatch(setMessage(props.successMessage, 'success', 'onNavigate'))

        if (props.saveAndNewClicked) {
          if (!props.initiateReplacement && !props.isDeviceReplacement) {
            // save data to store if "Save & New" was clicked
            Store.dispatch(
              setSaveDeviceAndPassData({
                type: props.data.type,
                manufacturer: props.data.manufacturer,
                model: props.data.model,
                carrier: props.data.carrier,
                site: props.data.site,
                center: props.data.center,
                production_date: props.data.production_date,
                warranty_expiration_date: props.data.warranty_expiration_date,
                serviceStatus: props.data.serviceStatus,
              }),
            )
          }
          window.location.href = props.successNav
          return
        } else {
          props.navigate(props.successNav)
        }
      }
      props.setShowOverlay(false)
    })

  return true
}

export default prepareSubmitForm
